import { PendenciasModal } from '@core/components/PendenciasCobranca';
import React, { useContext } from 'react';
import { ContaReceberContext } from '../../contaReceberContext';

const ContaReceberPendenciasModal = () => {
  const [visualizarPendencias, setVisualizarPendencias] = useContext(ContaReceberContext).visualizarPendencias;
  const [pendencias] = useContext(ContaReceberContext).pendencias;

  const handleCancelar = () => setVisualizarPendencias(false);

  return <PendenciasModal show={visualizarPendencias} pendencias={pendencias} onClose={handleCancelar} />;
};

export default ContaReceberPendenciasModal;
